import { css } from 'lit'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const style = css`
  .row {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing04};
    
    @media(min-width: ${SCREENS.small}) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }
  }
`
